define('plugin/contact-widget/view/ContactWidgetIndexView',['require','lib/view/FormView'],function (require) {

    var FormView = require('lib/view/FormView');

    return FormView.extend({

        tagName: 'div',

        template: '#contact_widget_index_view',

        ui: {
            input: ':input',
            send: '.send-message-button'
        },

        triggers: {
            'click @ui.send': 'sendMessage',
        },

        events: {
            'change @ui.input': 'changeInput',
        },

        modelEvents: {
            'invalid': 'render',
            'error': 'render'
        },
        _companyModel: null,

        initialize: function () {
            this._companyModel = this.getOption('companyModel');

            this.listenTo(this._companyModel, 'sync', this.render);
        },

        changeInput: function(event) {
            var el = event.target;
            var name = el.name.replace('contact_widget__', '');
            if (name) {
                this.model.set(name, $(el).val());
            }
        },

        serializeData: function () {
            var data = this._serializeData();
            if (this._companyModel) {
                data.work_day_names = new Date().getWeekDaysList('medium');

                var companyData = this._companyModel.toJSON();
                _.each(companyData.opening_hours_info, function (value, key) {
                    value.day_name_short = data.work_day_names[key];
                });

                data.company_data = companyData;
            }

            data.current_url = location.href;

            return data;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'contact_widget'
            });
        }

    });

});

